const core_api = process.env.REACT_APP_PAYMENT;
const payment_url = process.env.REACT_APP_PAYMENT_URL;

export { core_api, payment_url };